// import "./wdyr";
import React, { StrictMode } from "react";
import { render } from "react-dom";

import "bootstrap/dist/css/bootstrap.css";
import "regenerator-runtime/runtime";
import "core-js/stable";

import App from "./App";

render(
  <StrictMode>
    <App />
  </StrictMode>,
  document.getElementById("root")
);
